// extracted by mini-css-extract-plugin
export default {"container":"container-14iWQ","area-close":"area-close-EENDS","icon-close":"icon-close-8GelJ","area-content":"area-content-1PY0z"};